export default function About() {
  return (
    <section id="about" className="section-anchor py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">关于911爆料网</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">你的专属吃瓜情报站</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-1">
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4">全网吃瓜内容聚合平台</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                911爆料网创立以来，始终专注于为吃瓜群众提供最新、最全、最热的娱乐八卦与热点爆料内容。我们聚合全网范围内的911吃瓜最新动态，涵盖明星绯闻、综艺内幕、直播圈八卦、网红争议以及社会热点事件追踪。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                平台采用人工筛选与智能聚合相结合的运营模式，确保每一条爆料的真实性和时效性。无论是微博热搜、抖音热议，还是豆瓣小组、知乎热帖，只要是有料的911吃瓜事件，你都能在这里找到完整的来龙去脉。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们鼓励用户匿名投稿，严格保护爆料人隐私。911爆料网不做价值判断，只做信息搬运，让每一个吃瓜人都能自由获取资讯、独立判断是非。
              </p>
            </div>

            <div className="w-full lg:w-[280px] shrink-0">
              <div className="grid grid-cols-2 gap-3">
                {[
                  { num: '5000+', desc: '吃瓜事件收录' },
                  { num: '日更', desc: '热点追踪频率' },
                  { num: '7x24', desc: '全天候运营' },
                  { num: '匿名', desc: '隐私安全保障' },
                ].map((item, i) => (
                  <div key={i} className="bg-background-50 rounded-xl p-4 text-center border border-background-200/60">
                    <div className="text-xl md:text-2xl font-heading font-bold text-primary-600 mb-1">{item.num}</div>
                    <div className="text-xs text-foreground-500">{item.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}